class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });     
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.updateQueue = new Map(); // Queue for pending quantity updates
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

//   initializeCartItemUI() {
//   const cart_items = this.querySelectorAll(".cart-items .cart-item");
//   console.log("cart_items", cart_items);

//   if (cart_items.length) {
//     cart_items.forEach((cart_item) => {
//       // Handle Tabs per cart-item
//       const tabs = cart_item.querySelectorAll(".tab-link");
//       const tabContents = cart_item.querySelectorAll(".tab-content");

//       tabs.forEach(tab => {
//         tab.addEventListener("click", function () {
//           const tabValue = this.getAttribute("data-tab-value");

//           tabs.forEach(t => t.classList.remove("active"));
//           tabContents.forEach(content => content.classList.remove("active"));

//           this.classList.add("active");
//           cart_item.querySelector(`.tab-content[data-tab-info="${tabValue}"]`).classList.add("active");
//         });
//       });

//       // Handle size dropdown
//       const disclosure = cart_item.querySelector(".disclosure");

//       if (disclosure) {
//         const disclosure_button = disclosure.querySelector(".disclosure__button");
//         const listWrapper = disclosure.querySelector(".disclosure__list-wrapper");
//         const inputField = cart_item.querySelector("input.form_standard-size");
//         const self = this; // Keep reference to class context

//         disclosure_button.addEventListener("click", function (event) {
//           event.stopPropagation();
//           listWrapper.classList.toggle("hidden");
//         });

//         disclosure.querySelectorAll(".disclosure__list-wrapper li").forEach((disclosure_item) => {
//           disclosure_item.addEventListener("click", () => {
//             listWrapper.classList.add("hidden");
//             const selectedVal = disclosure_item.getAttribute("data-list-value");

//             if (inputField) {
//               inputField.value = selectedVal;
//               // Optional method, call only if it exists
//               self.updateCartProperties?.(cart_item, selectedVal);
//             }

//             disclosure_button.querySelector("span").textContent = selectedVal;

//             const accordianWrapper = disclosure.closest(".cart-accordian");
//             if (accordianWrapper) {
//               accordianWrapper.classList.add("active");
//             }

//             const allInputs = self.querySelectorAll(".form_standard-size");
//             const allFilled = Array.from(allInputs).every(input => input.value.trim() !== "");
//             const cartCtas = self.querySelector(".cart__footer .cart__ctas");

//             if (cartCtas) {
//               if (allFilled) {
//                 cartCtas.removeAttribute("disabled");
//               } else {
//                 cartCtas.setAttribute("disabled", "disabled");
//               }
//             }
//           });
//         });

//         // Close dropdown if clicked outside
//         document.addEventListener("click", function (event) {
//           if (!disclosure.contains(event.target)) {
//             listWrapper.classList.add("hidden");
//           }
//         });
//       }
//     });
//   }
// }
  
 initializeCartUI() {
 
  // Handle Accordion behavior
  const headers = document.querySelectorAll(".cart-accordian .accordion-header");

  headers.forEach(function (header) {
    header.addEventListener("click", function () {
      const content = header.nextElementSibling;
      if (!content) return;

       const isHidden = content.hasAttribute("hidden");

      // Close all other accordions
     document.querySelectorAll(".accordion__content").forEach(el => el.setAttribute("hidden", true));
    document.querySelectorAll(".accordion-header").forEach(el => el.removeAttribute("open"));

      if (isHidden) {
        content.removeAttribute("hidden");
        header.setAttribute("open", "");

        if (header.getAttribute("data") === "size") {
          const firstTab = content.querySelector(".tab-link");
          if (firstTab) firstTab.click();
        }

        // Setup tab switching inside this accordion
        const tabLinks = content.querySelectorAll(".tab-link");
        const tabContents = content.querySelectorAll(".tab-content");

        tabLinks.forEach(link => {
          link.addEventListener("click", function (e) {
            e.preventDefault();
            const value = this.getAttribute("data-tab-value");

            tabLinks.forEach(l => l.classList.remove("active"));
            tabContents.forEach(c => c.setAttribute("hidden", true));

            this.classList.add("active");
            const selectedTab = content.querySelector(`#${value}`);
            if (selectedTab) selectedTab.removeAttribute("hidden");
          });
        });
      } else {
        content.setAttribute("hidden", true);
        header.removeAttribute("open");
      }
    });
  });

  // Handle cart items functionality
  const cart_items = document.querySelectorAll(".cart-items .cart-item");

  if (cart_items.length) {
    cart_items.forEach((cart_item) => {
      // Tabs inside each cart item
      const tabs = cart_item.querySelectorAll(".tab-link");
      const tabContents = cart_item.querySelectorAll(".tab-content");

      tabs.forEach(tab => {
        tab.addEventListener("click", function () {
          const tabValue = this.getAttribute("data-tab-value");

          tabs.forEach(t => t.classList.remove("active"));
          tabContents.forEach(content => content.classList.remove("active"));

          this.classList.add("active");
          const targetContent = cart_item.querySelector(`.tab-content[data-tab-info="${tabValue}"]`);
          if (targetContent) targetContent.classList.add("active");
        });
      });

      // Size dropdown
      const disclosure = cart_item.querySelector(".disclosure");

      if (disclosure) {
        const disclosure_button = disclosure.querySelector(".disclosure__button");
        const listWrapper = disclosure.querySelector(".disclosure__list-wrapper");
        const inputField = cart_item.querySelector("input.form_standard-size");

        disclosure_button.addEventListener("click", function (event) {
          event.stopPropagation();
          listWrapper.classList.toggle("hidden");
        });

        disclosure.querySelectorAll(".disclosure__list-wrapper li").forEach((disclosure_item) => {
          disclosure_item.addEventListener("click", function () {
            listWrapper.classList.add("hidden");
            const selectedVal = this.getAttribute("data-list-value");

            if (inputField) {
              inputField.value = selectedVal;
              updateCartProperties(cart_item, selectedVal); // assuming this is defined elsewhere
            }

            disclosure_button.querySelector("span").textContent = selectedVal;

            const accordianWrapper = disclosure.closest(".cart-accordian");
            if (accordianWrapper) {
              accordianWrapper.classList.add("active");
            }

            const allInputs = document.querySelectorAll(".form_standard-size");
            const allFilled = Array.from(allInputs).every(input => input.value.trim() !== "");
            const cartCtas = document.querySelector(".cart__footer .cart__ctas");

            if (allFilled) {
              cartCtas.removeAttribute("disabled");
            } else {
              cartCtas.setAttribute("disabled", "disabled");
            }
          });
        });

        // Close dropdown on outside click
        document.addEventListener("click", function (event) {
          if (!disclosure.contains(event.target)) {
            listWrapper.classList.add("hidden");
          }
        });
      }
    });
  }
}


  
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }
  
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    
    // If already processing this line, queue the new request instead of ignoring
    if (lineItem && lineItem.classList.contains('cart-item--syncing')) {
      this.queueQuantityUpdate(line, quantity, name, variantId);
      return;
    }
    
    // Optimistic update: Update UI immediately before server call
    this.updateQuantityOptimistic(line, quantity);
    
    // Disable quantity controls during processing
    if (lineItem) {
      lineItem.classList.add('cart-item--syncing');
      this.disableQuantityControls(lineItem);
      
      // Failsafe: re-enable controls after 10 seconds if something goes wrong
      setTimeout(() => {
        if (lineItem.classList.contains('cart-item--syncing')) {
          console.warn('Cart update took too long, re-enabling controls for line', line);
          lineItem.classList.remove('cart-item--syncing');
          this.enableQuantityControls(lineItem);
        }
      }, 10000);
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
         const cartMainContent = document.getElementById('MainContent');
        
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartMainContent) cartMainContent.classList.toggle('is-empty', parsedState.item_count === 0);
        
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
    
        });
        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((error) => {
        console.error('Cart update failed:', error);
        
        // Revert optimistic update on error
        this.revertOptimisticUpdate(line);
        
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        // Remove syncing state and re-enable controls
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem) {
          lineItem.classList.remove('cart-item--syncing');
          this.enableQuantityControls(lineItem);
        }
        
        // Process any queued updates for this line
        this.processQueuedUpdate(line);
      });
  }

  queueQuantityUpdate(line, quantity, name, variantId) {
    console.log('Queueing quantity update for line', line, 'to quantity', quantity);
    // Store the latest requested quantity for this line (overwrites previous queued value)
    this.updateQueue.set(line, { quantity, name, variantId });
    
    // Also update the UI optimistically with the new value
    this.updateQuantityOptimistic(line, quantity);
  }

  processQueuedUpdate(line) {
    if (this.updateQueue.has(line)) {
      const queuedUpdate = this.updateQueue.get(line);
      this.updateQueue.delete(line);
      console.log('Processing queued update for line', line, 'to quantity', queuedUpdate.quantity);
      
      // Small delay to ensure UI is ready
      setTimeout(() => {
        this.updateQuantity(line, queuedUpdate.quantity, queuedUpdate.name, queuedUpdate.variantId);
      }, 100);
    }
  }

  updateQuantityOptimistic(line, quantity) {
    // Get current item price for calculations
    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (!lineItem) return;

    // Update quantity input immediately
    const quantityInput = lineItem.querySelector('.quantity__input');
    if (quantityInput) {
      quantityInput.value = quantity;
    }

    // Calculate and update line total immediately
    const priceElement = lineItem.querySelector('.cart-item__price-wrapper .price');
    const unitPrice = parseFloat(lineItem.dataset.unitPrice || 0);
    
    if (priceElement && unitPrice) {
      const newTotal = (unitPrice * quantity) / 100; // Shopify prices are in cents
      const formattedPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EUR'
      }).format(newTotal);
      
      // Update the line total
      const totalElement = priceElement.querySelector('.price__value') || priceElement;
      if (totalElement) {
        totalElement.textContent = formattedPrice;
      }
    }

    // Update cart totals optimistically
    this.updateCartTotalsOptimistic();
    
    // If quantity is 0, hide the item immediately
    if (quantity === 0) {
      lineItem.style.display = 'none';
    } else {
      lineItem.style.display = '';
    }
  }

  updateCartTotalsOptimistic() {
    // Calculate new cart total based on visible items
    let newTotal = 0;
    const cartItems = this.querySelectorAll('.cart-item:not([style*="display: none"])');
    
    cartItems.forEach(item => {
      const quantityInput = item.querySelector('.quantity__input');
      const unitPrice = parseFloat(item.dataset.unitPrice || 0);
      
      if (quantityInput && unitPrice) {
        const quantity = parseInt(quantityInput.value) || 0;
        newTotal += (unitPrice * quantity) / 100;
      }
    });

    // Update cart footer totals
    const totalElements = document.querySelectorAll('.totals__total-value, .cart-item-summary .price');
    totalElements.forEach(element => {
      if (element) {
        const formattedTotal = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'EUR'
        }).format(newTotal);
        element.textContent = formattedTotal;
      }
    });

    // Update cart count in header
    const cartCount = Array.from(cartItems).reduce((total, item) => {
      const quantityInput = item.querySelector('.quantity__input');
      return total + (parseInt(quantityInput?.value) || 0);
    }, 0);

    // Update cart badges
    const cartBadges = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
    cartBadges.forEach(badge => {
      if (badge) {
        badge.textContent = cartCount;
      }
    });
  }

  disableQuantityControls(lineItem) {
    // Disable quantity buttons and input to prevent rapid clicks
    const quantityButtons = lineItem.querySelectorAll('.quantity__button');
    const quantityInput = lineItem.querySelector('.quantity__input');
    
    quantityButtons.forEach(button => {
      button.disabled = true;
      button.classList.add('disabled');
    });
    
    if (quantityInput) {
      quantityInput.disabled = true;
    }
  }

  enableQuantityControls(lineItem) {
    // Re-enable quantity buttons and input
    const quantityButtons = lineItem.querySelectorAll('.quantity__button');
    const quantityInput = lineItem.querySelector('.quantity__input');
    
    quantityButtons.forEach(button => {
      button.disabled = false;
      button.classList.remove('disabled');
      // Ensure the button is clickable
      button.style.pointerEvents = '';
    });
    
    if (quantityInput) {
      quantityInput.disabled = false;
      quantityInput.style.pointerEvents = '';
    }
  }

  revertOptimisticUpdate(line) {
    // Reload the cart section to get the correct server state
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        if (sourceQty) {
          this.innerHTML = sourceQty.innerHTML;
        }
      })
      .catch((error) => {
        console.error('Failed to revert optimistic update:', error);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);   
        this.initializeCartUI();
       // this.initializeCartItemUI(); 
      console.log("111");
    }, 1000);   
    setTimeout(() => {
       const submitButton = document.querySelector('.cart__footer .cart__ctas'); // Adjust if needed
        const cartItems = document.querySelectorAll('.cart-item.cst-cart-item');
        const nonGiftItems = document.querySelectorAll('.cart-item.cst-cart-item:not(.gift-product)');
      console.log("nonGiftItems",nonGiftItems);
        const totalNonGift = nonGiftItems.length;
      
        if (totalNonGift == 0) {
          // All items are gift products — enable the button
          submitButton.removeAttribute('disabled');
          console.log("Only gift items — button enabled");
        } else {
          // At least one non-gift product exists
          const activeCount = [...nonGiftItems].filter(item =>
            item.querySelector('.cart-accordian.size_accordion.active')
          ).length;
      
          if (activeCount === totalNonGift) {
            // All non-gift items have active size accordion — enable
            submitButton.removeAttribute('disabled');
            console.log("All non-gift items selected — button enabled");
          } else {
            // Some non-gift items missing selection — disable
            submitButton.setAttribute('disabled', 'disabled');
            console.log("Missing selections — button disabled");
          }
        }
    },1500);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  // Legacy loading methods - now simplified since we use optimistic updates
  enableLoading(line) {
    // Minimal loading state - just for server sync indicator
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    // Clean up any remaining loading states
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
